angular.module('charts')
  .directive("progressCircle", function() {
    return {
      restrict: "E",
      scope: {
        percent: '@'
      },
      transclude: true,
      replace: false,
      templateUrl: '/resources/charts/partials/progress-circle.html',
      controller: ['$scope', '$element', '$rootScope', '$timeout', function($scope, $element, $rootScope, $timeout) {

        $scope.$watchCollection('percent', function(percent) {
          $timeout(function() {
            if (percent) {
              $scope.drawGraph();
            }
          }, 0);

        });

        $scope.drawGraph = function() {
          $scope.circle = {
            chartSize: '100%',
            chartInnerSize: '90%',
            chartWidth: 100,
            chartHeight: 100
          };

          $scope.percent = parseInt($scope.percent);

          $scope.bgcolor = "#7BC8E4";
          $scope.remainingPercentage = 100 - $scope.percent;

          $scope.chartConfig = {
            chart: {
              type: "pie",
              backgroundColor: '#FFFCF9',
              spacingTop: 0,
              spacingBottom: 0,
              spacingLeft: 0,
              spacingRight: 0,
              margin: [0, 0, 0, 0]
            },
            plotOptions: {
              pie: {
                shadow: false,
                borderWidth: 0
              }
            },
            series: [{
              data: [{
                y: $scope.percent,
                color: $scope.bgcolor
              }, {
                y: $scope.remainingPercentage,
                color: "#D1CFD2"
              }],
              size: $scope.circle.chartSize,
              innerSize: $scope.circle.chartInnerSize,
              enableMouseTracking: false,
              dataLabels: {
                enabled: false
              }
            }],
            title: {
              text: null
            },
            tooltip: false,
            credits: {
              enabled: false
            },
            loading: false,
            size: {
              width: $scope.circle.chartWidth,
              height: $scope.circle.chartHeight
            },
            func: function(chart) {}
          };
        };

      }]
    };
  });
